import { useEffect, useState } from 'react';
import CourseLesson from 'src/model/CourseLesson';
import CourseLessonRetriever from 'src/retriever/CourseLessonRetriever';

export function useGetCourseLesson(
  setError: (isError: boolean) => void,
  courseLessonId?: string,
): CourseLesson {
  const [courseLessonState, setCourseLesson] = useState({
    courseLessonId: 'temporary_id',
    markdownPath: 'resource/course/coding_interview/test_markdown.md',
  } as CourseLesson);
  useEffect(() => {
    CourseLessonRetriever.getCourseLesson(courseLessonId)
      .then((courseLesson) => {
        setCourseLesson(courseLesson);
      })
      .catch(() => {
        setError(true);
      });
  }, []);

  return courseLessonState;
}

export default function useListCourseLesson(
  setError: (isError: boolean) => void,
  courseChapterId?: string,
): Array<CourseLesson> {
  const [courseLessonsState, setCourseLessons] = useState([] as Array<CourseLesson>);
  useEffect(() => {
    CourseLessonRetriever.listCourseLesson(courseChapterId)
      .then((courseLessons) => {
        setCourseLessons(courseLessons);
      })
      .catch(() => {
        setError(true);
      });
  }, []);
  return courseLessonsState;
}
